import {WF_OWNED_SITES, EXIT_OVERLAY_EXCEPTIONS} from './constants';

let lastFocus = '';

///////////////////////////////////////////////////////
    // Add click event listeners for any EXTERNAL 
    // NON-WF-owned link only. Doing this avoids changing any
    // component code to accommodate anchor tags in all 
    // the featured article body content as well as anywhere
    // else throughout the site.
    ///////////////////////////////////////////////////////
   export function addExitClickListeners() {

      // get all anchor tags with target="blank" or target="_blank"
      let anchorLinks = document.querySelectorAll('a[target="_blank"], a[target="blank"]');

      // don't count the external link used for the Continue link - so we remove it from our list
      anchorLinks = Array.from(anchorLinks).filter(link => link.id !== 'modal-continue');

      anchorLinks.forEach(anchorLink => {
        // using each external link from the DOM, check that against the array of WF 
        // owned sites and if we DON'T find that link inside the WF_OWNED_SITES array, 
        // then we add the click event listener to show the exitOverlay

        if (anchorLink.dataset.clickListener !== 'true' && !WF_OWNED_SITES.find(wfURL => anchorLink.href.indexOf(wfURL) > -1) || anchorLink.dataset.clickListener !== 'true' && EXIT_OVERLAY_EXCEPTIONS.find(wfURL => anchorLink.href.indexOf(wfURL) > -1)) {                
            anchorLink.setAttribute('data-click-listener', 'true');
            anchorLink.addEventListener('click', displayExitOverlay);
        }
      });
    }

    ///////////////////////////////////////////////////////
    // Show exit overlay function
    // called from click event listener
    ///////////////////////////////////////////////////////
    export function displayExitOverlay(event) {
      event.preventDefault();
      
      const modal = document.getElementById('modal');

      if (modal.dataset.keydownListener !== 'true') {
        // trap the tab order in the modal
            trapTabOrderinModal(modal);
      }

      const continueLink = document.getElementById('modal-continue');
      continueLink.setAttribute('tabindex', '0');
      
      let continueClickListener;
      continueLink.addEventListener('click', continueClickListener = () => {
        // close exit overlay after user clicks continue
        closeExitOverlay(); 
        continueLink.removeEventListener('click', continueClickListener); 
      });

      document.getElementById('modal-cancel').setAttribute('tabindex', '0');
      document.getElementById('modal-x-icon').setAttribute('tabindex', '0');
      lastFocus = event.currentTarget;
      continueLink.href = event.currentTarget.href;
      const overlay = document.getElementById('overlay');
      overlay.classList.add('show');

      // set aria-hidden TRUE to other elements - DC
      let mainChildren = document.querySelectorAll('main > div:not(#overlay)');
      mainChildren.forEach(child => {
        child.setAttribute('aria-hidden', 'true');
      });

      document.querySelector('nav').setAttribute('aria-hidden', 'true');
      document.querySelector('#footer').setAttribute('aria-hidden', 'true');
      // ----------------------------------------

      setTimeout(() => {
        modal.classList.add('fade-in');
      }, 100);
      document.getElementById('modal-x-icon').focus();
    };

    ///////////////////////////////////////////////////////
    // Close/Cancel exit overlay function
    // called from ExitOverlay component
    ///////////////////////////////////////////////////////
    export function closeExitOverlay() {
      const overlay = document.getElementById('overlay');
      overlay.classList.remove('show');

      // set aria-hidden FALSE to other elements - DC
      let mainChildren = document.querySelectorAll('main > div:not(#overlay)');
      mainChildren.forEach(child => {
        child.setAttribute('aria-hidden', 'false');
      });

      document.querySelector('nav').setAttribute('aria-hidden', 'false');
      document.querySelector('#footer').setAttribute('aria-hidden', 'false');
      // ----------------------------------------

      const modal = document.getElementById('modal');
      modal.classList.remove('fade-in');
      document.getElementById('modal-continue').setAttribute('tabindex', '-1');
      document.getElementById('modal-cancel').setAttribute('tabindex', '-1');
      document.getElementById('modal-x-icon').setAttribute('tabindex', '-1');
      lastFocus.focus();
    }

    ///////////////////////////////////////////////////////
    // Accessibility Requirement
    // Traps tab key in modal when it is open.
    ///////////////////////////////////////////////////////
    export function trapTabOrderinModal(modal) {
      modal.addEventListener('keydown', e => { 
        modal.setAttribute('data-keydown-listener', 'true');
        switch(e.which) {
          case 9: { // tab key
            if (e.shiftKey) {
              if (document.activeElement.id === 'modal-x-icon') {
                e.preventDefault();
                document.getElementById('modal-continue').focus();
              } 
            } else {
              if (document.activeElement.id === 'modal-continue') {
                e.preventDefault();
                document.getElementById('modal-x-icon').focus();
              } 
            }
            break;
          }
          case 27: { // ESC key
            closeExitOverlay();
            break;
          }
        }
      });
    }